import { Component, Method, h } from '@stencil/core';

import { conditions } from '../../../../../utils/utils.consumer-market-confident';

@Component({
  tag: 'key-factor-condition-dialog',
  styleUrl: 'key-factor-condition-dialog.css',
})
export class KeyFactorConditionDialog {
  private modal: HTMLIcoModalElement;

  @Method()
  async open() {
    this.modal.open();
  }

  @Method()
  async close() {
    this.modal.close();
  }

  render() {
    return (
      <ico-modal ref={(el) => (this.modal = el)} id="keyfactor-condition" slot="modal" displayX={true}>
        <div slot="header">
          <span class="font-open-sans text-base font-bold">Condition Descriptions</span>
        </div>
        <div slot="main">
          {conditions.map((condition) => (
            <ConditionDescription title={condition.title} percentage={condition.percentage} descriptions={condition.descriptions} />
          ))}
          <span class="font-open-sans text-sm font-normal">
            If you receive an Instant Cash Offer, your vehicle will also be inspected with a detailed condition assessment by the dealer and your offer amount may change. Kelley
            Blue Book does not provide values for cars in poor condition.
          </span>
        </div>
      </ico-modal>
    );
  }
}

const ConditionDescription = ({ title = '' as string, percentage = '' as string, descriptions = [] as Array<string> }) => (
  <div class="my-1">
    <span class="text-sm font-montserrat font-extrabold">{title}</span>
    <p class="font-open-sans text-sm font-bold my-0">{percentage} of all cars we value</p>
    <ul class="pl-6 marker:text-bullet font-open-sans text-sm font-normal">
      {descriptions.map((description, index) => (
        <li key={index}>{description}</li>
      ))}
    </ul>
  </div>
);
